/*
 * Copyright 2026 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Subject} from 'rxjs';

export class ChromingUtil {
  private static _onResize$: Subject<void> = new Subject();

  private static _resizeObserver = new ResizeObserver(() => {
    this._onResize$.next();
  });

  public static get onResize$() {
    return this._onResize$.asObservable();
  }

  public static observeElementResize(element: HTMLElement) {
    this._resizeObserver.observe(element);
  }

  public static unobserveElementResize(element: HTMLElement) {
    this._resizeObserver.unobserve(element);
  }

  public static disconnectResizeObserver() {
    this._resizeObserver.disconnect();
  }
}
